import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router'
import * as actions from '../../state/actions'
import * as project from '../../utils/project'
import * as mtLess from '../../less/mt.less'
import * as sbadmin2Less from '../../less/sbadmin2/sb-admin-2.less'
import Spinner from '../../components/common/Spinner'
import Navigation from '../../components/common/Navigation'

class Manager extends Component {

    getTitle() {
        var self = this
        return self.props.isReady && ((self.props.profile && self.props.profile.app && self.props.profile.app.name) || (self.props.app && self.props.app.name))
    }

    componentWillMount() {
        var self = this
        var promise = Promise.resolve()

        promise = promise.then(() => {
            return self.props.actions.appGetOneCodename(self.props.params.appCodename)
        })

        return promise
    }

    componentDidUpdate() {
        var self = this
        if (self.props.isReady) {
            var title = self.getTitle()
            if (!title) {
                self.props.actions.appGetOneCodename(self.props.params.appCodename)
            }
        }
    }

    render () {
        var self = this

        var title = self.getTitle()
        if (!self.props.isReady || !title || !self.props.profile || !self.props.profile.profile || !self.props.app) {
            return (
                <Spinner />
            )
        } else {
            let urls = [
                {
                    url: '/dashboard',
                    name: 'Dashboard',
                    icon: 'fa-home',
                    condition: function() {
                        return self.props.profile.profile >= 1000
                    }
                }, {
                    url: '/user',
                    name: 'Administradores',
                    icon: 'fa-user',
                    condition: function() {
                        return self.props.profile.profile >= 2000
                    }
                }, {
                    url: '/transactions',
                    name: 'Transacciones',
                    icon: 'fa-credit-card',
                    condition: function() {
                        return self.props.profile.profile >= 1000
                    }
                }, {
                    url: '/entity',
                    name: 'Entidades',
                    icon: 'fa-university',
                    condition: function() {
                        return self.props.profile.profile >= 1000
                    }
                }, {
                    url: '/subscriptions',
                    name: 'Subscripciones',
                    icon: 'fa-handshake-o',
                    condition: function() {
                        return self.props.profile.profile >= 1000
                    }
                }
            ]

            return (
                <div id="wrapper">
                    <Navigation title={ title }>
                        <div className="navbar-default sidebar" role="navigation">
                            <div className="sidebar-nav navbar-collapse">
                                <ul className="nav" id="side-menu">
                                    { urls.map((url, index) => {
                                        if (url.condition()) {
                                            if (url.collapse) {
                                                return (<li key={'collapse-' + index}>
                                                    <a><i className={`fa ${url.icon} fa-fw`}></i> {url.name}</a>
                                                    <ul className="nav nav-second-level">
                                                        { url.urls.map(slUrl => {
                                                            return (<li key={slUrl.url}>
                                                                <Link to={`/manager/${self.props.params.appCodename}${slUrl.url}`} activeClassName="active">{slUrl.name}</Link>
                                                            </li>)
                                                        }) }
                                                    </ul>
                                                </li>)
                                            } else {
                                                return (<li key={url.url}>
                                                    <Link to={`/manager/${self.props.params.appCodename}${url.url}`} activeClassName="active"><i className={`fa ${url.icon} fa-fw`}></i> {url.name}</Link>
                                                </li>)
                                            }
                                        }
                                    }) }
                                </ul>
                            </div>
                        </div>
                    </Navigation>
                    <div id="page-wrapper">
                        { self.props.children }
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        profile: state.profile,
        isReady: state.isReady
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Manager)



// WEBPACK FOOTER //
// ./containers/Manager/index.js